import metaTagsMixin from '~coreModules/core/js/seo/meta-tags';
import SITE_META from '~modules/core/js/seo/meta-constants';

export default {
    mixins: [metaTagsMixin],
    data() {
        return { SITE_META };
    },
};
